import LoveMapProduct from './components/LoveMapProduct'
import LoveMapLoader from './components/LoveMapLoader'

export default {
    install(Vue, option) {
        Vue.component('LoveMapProduct', LoveMapProduct);
        Vue.component('LoveMapLoader', LoveMapLoader);
    }
};